import { Clock } from "lucide-react";
import { useRef } from "react";

import { NoticeDialog } from "@/components/notice-dialog";
import { Button } from "@/components/ui/button";
import { useTranslation } from "@/store/locale";

/**
 * The last ten seconds of an idle session, counted out loud.
 *
 * Being signed out with no warning reads as a fault rather than a policy, so
 * the countdown says what is about to happen and how long there is to stop it.
 * Any click or keypress cancels it — the button is somewhere to aim, not the
 * only way back.
 */
export function IdleDialog({
  secondsLeft,
  onStay,
}: {
  secondsLeft: number;
  onStay: () => void;
}) {
  const t = useTranslation();
  const ref = useRef<HTMLDialogElement>(null);

  return (
    <NoticeDialog
      dialogRef={ref}
      icon={Clock}
      title={t("idle.warnTitle")}
      description={t("idle.warnBody").replace("{n}", String(secondsLeft))}
      onClose={onStay}
      actions={<Button onClick={() => ref.current?.close()}>{t("idle.stay")}</Button>}
    />
  );
}
